export default {
  nav: {
    home: 'Home',
    shoppingGuide: 'Shopping Guide',
    categories: 'Categories',
    guides: 'Guides',
    review: 'Review',
    shipping: 'Shipping',
    safety: 'Safety',
    articles: 'Articles',
    cta: 'Buy It Now',
  },
  footer: {
    disclaimerTitle: 'Important Disclaimer',
    disclaimer: 'This is an independent resource website and is not affiliated with, endorsed by, or connected to AllChinaBuy or any related platform. All trademarks belong to their respective owners.',
    safety: 'Safety',
    privacy: 'Privacy',
    terms: 'Terms',
    about: 'About',
    copyright: 'All rights reserved.',
  },
  notFound: {
    title: 'Page not found',
    subtitle: 'The page you are looking for does not exist.',
    backHome: 'Back to home',
  },
};